import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '../enums';

@Pipe({
  name: 'arabicNumber',
})
export class ArabicNumberPipe implements PipeTransform {
  public transform(value: number, lang: Language): number | string {
    if (lang === 'ar') {
      return new Intl.NumberFormat('ar-SA', {}).format(value);
    }
    return value;
  }
}
